import { render, staticRenderFns } from "./Block2.vue?vue&type=template&id=4a6cc464&scoped=true&"
import script from "./Block2.vue?vue&type=script&lang=js&"
export * from "./Block2.vue?vue&type=script&lang=js&"
import style0 from "./Block2.vue?vue&type=style&index=0&id=4a6cc464&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6cc464",
  null
  
)

export default component.exports